import { DataTable } from '@pihealth/common-ui-library';
import React, { useEffect, useState } from 'react';
import staticData from '../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setSelectedRowData, setReportCMPArr } from 'src/store/sqReport';
import { useSqReport } from './useSqReport';
import { useUtil } from 'src/components/hooks/useUtil';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import VersionHistory from 'src/components/common/VersionHistory';
import { useUser } from 'src/components/hooks/useUser';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';

const SQReportListView: React.FunctionComponent<any> = () => {
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { preferences } = useUser();
  const { handleError } = useUtil();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector((state: any) => state.site.selectedCountry);
  const selectedSite = useAppSelector((state: any) => state.site.selectedSite);
  const { selectedAppSection } = useSelectedAppInfo();
  const { applicationModuleSection } = useFieldTranslation();
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<any>([]);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');

  const rowClick = (rowData: any) => {
    dispatch(setSelectedRowData(rowData));
    dispatch(setReportCMPArr('sqreportpage'));
  };
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      rowClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const { getAllSQReports, getAllSqReportData, getAllSqReportIsError, getAllSqReportLoading, getAllSqReportError } =
    useSqReport();
  useEffect(() => {
    getAllSQReports({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection,
      application_module_section: applicationModuleSection.sqReport
    });
  }, [selectedSite, studyId, selectedCountry]);
  useEffect(() => {
    if (getAllSqReportData && Array.isArray(getAllSqReportData)) {
      setRows(
        getAllSqReportData.map((item: any) => {
          return {
            ...item,
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            start_date: getPreferredDateTimeInLocal(item.start_date),
            major_version: Number(item.major_version).toFixed(1).toString()
          };
        })
      );
    }
  }, [getAllSqReportData]);

  useEffect(() => {
    if (getAllSqReportIsError) {
      handleError(getAllSqReportError);
      setRows([]);
    }
  }, [getAllSqReportIsError]);
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${staticData.sqReportView.file_export_name} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <>
      <DataTable
        rows={rows}
        columns={staticData.sqReportView.dataTablecolumns}
        datePreference={preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy'}
        actions={actions}
        loading={getAllSqReportLoading}
        showDateAndTime
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
      />
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'SQ Report'}
        />
      ) : (
        ''
      )}
    </>
  );
};
export default SQReportListView;
